var map = {
	"./ch.json": "fe61",
	"./da.json": "6398",
	"./de.json": "2508",
	"./en.json": "e088",
	"./es.json": "d90a",
	"./fi.json": "86a4",
	"./fr.json": "2394",
	"./it.json": "06b7",
	"./nl.json": "674d",
	"./pl.json": "b890",
	"./pt.json": "6a7b",
	"./sq.json": "28ca",
	"./sv.json": "3f3d",
	"./uk.json": "0641"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15a4";